import { get } from "@insite/client-framework/Services/ApiService";

import { AIProtonModel, GetAIProtonApiParameter } from "@NA/Widgets/AIProton/AIProtonModel";

const buyAgainUrl = "api/v1/getReorderRecommendation";

export async function getAIProtonProducts(parameter: GetAIProtonApiParameter) {
    return get<AIProtonModel[]>(`${buyAgainUrl}`, parameter, {
        userID: parameter.userID,
    });
}
